import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

// RxJS
import { catchError, throwError } from 'rxjs';

// Services
import { AuthService } from '../services/auth.service';

const PUBLIC_AUTH_PATHS = [
  '/auth/invite/validate',
  '/auth/complete-registration',
];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401 && !PUBLIC_AUTH_PATHS.some(path => req.url.includes(path))) {
        authService.logout();
      }
      return throwError(() => err);
    })
  );
};
